
import {initFactbox} from "./custom/factbox";
import {hideMobileMenu, showMobileMenu} from "./custom/mobileMenu";
import {initScrollVideo} from "./custom/scrollVideo";
import {initTabs} from "./custom/tabs";
import {initSlideBanners} from "./custom/slideBanners";
import {initItemboxListPreview} from "./custom/itemboxListPreview";
import {initProjectPreview} from "./custom/projects";
import {initItemcardGalleryAnimation} from "./custom/galleryAnimation";
import {initItemcardVideo} from "./custom/itemcardVideo";
import {initScrollytellingVideo} from "./custom/scrollytellingVideo";
import {initHorizontalInfoSlides} from "./custom/horizontalInfoSlides";
import {initStickyHeaderOnScroll} from "./custom/stickyHeaderOnScroll";
import {initBannerScrollAnimation} from "./custom/bannerScrollAnimation";
import {stickyBoxProjects} from "./custom/stickyBoxProjects";
import {initGallery} from "./custom/gallery";
import {initItemboxHospitality} from "./custom/itemboxHospitality";
import {initProjectBannersSlider} from "./custom/projectBannersSlider";
import {initTeamValuesSlider} from "./custom/teamValues";
import {initHistorySlider} from "./custom/history";
import hoverintent from "./custom/hoverintent";
import {initVehicleInUseSlider} from "./custom/vehicleInUseBanner";
import {loadLetter} from "./custom/loadLetter";
import {initRoadshowForms} from "./custom/roadshowForm";
import {initPromoBarModal} from "./custom/promoBarModal";
import {initAiVisionShare} from "./custom/aiVisionShare";
import {initCookieBanner} from "./custom/cookieBanner";
import {initVideoControls} from "./custom/videoControls";

// Direkt beim Laden ausführen: das DCcookie-Plugin hängt das Banner ca. 250 ms
// nach dem Laden ein, der Observer muss vorher stehen.
initCookieBanner();

document.addEventListener("DOMContentLoaded", () => {
    for(let contactBannerMedia of document.querySelectorAll(".contactBanner__media")){
        if(contactBannerMedia.dataset.video){
            let html = contactBannerMedia.dataset.video;
            html = html.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '');
            html = html.replace(/preload\s*=\s*["']auto["']/gi, 'preload="none"');
            html = html.replace(/\s*autoplay\s*/gi, ' ');
            contactBannerMedia.innerHTML = html;
        }
    }
})

document.addEventListener('DOMContentLoaded', function() {
    initAiVisionShare();
    initVideoControls();
    initFactbox();
    initScrollVideo();
    initTabs();
    initSlideBanners();
    initProjectPreview();
    initItemcardGalleryAnimation();
    initItemcardVideo();
    initScrollytellingVideo();
    initHorizontalInfoSlides();
    initBannerScrollAnimation();
    initGallery();
    initItemboxHospitality();
    initProjectBannersSlider();
    initTeamValuesSlider();
    initHistorySlider();
    initVehicleInUseSlider();
    initPromoBarModal();

    const header = document.getElementById('header');
    const mobileMenu = document.getElementById('js-mobileMenuEila');
    const mobileMenuToggle = document.getElementById("js-toggleMobileMenuNavigation");

    if(header){
        initStickyHeaderOnScroll(header);
    }

    if (header && mobileMenu && mobileMenuToggle) {

        mobileMenuToggle.addEventListener("click", function () {
            if(mobileMenuToggle.classList.contains("is-active")){
                hideMobileMenu(header, mobileMenu, mobileMenuToggle);
            }else{
                showMobileMenu(header, mobileMenu, mobileMenuToggle);
            }
        })
    }

    for (let pinBox of document.querySelectorAll(".js-stickyProjectBox")) {
        stickyBoxProjects(pinBox, {
            offsetTop: 30,
            selectorPinArea: ".js-stickyProjectBoxArea"
        });
    }

    for (let el of document.querySelectorAll('.eilaInfoTVBox, .eilaJob')) {
        hoverintent(el);
    }

    for (let el of document.querySelectorAll('.cLevelBox')) {
        hoverintent(el,200,()=>{
            el.classList.add("is-show-content-box");
            setTimeout(function () {
                el.classList.add("is-show-content-text");
            },300);
        },()=>{
            el.classList.remove("is-show-content-text");
            setTimeout(function () {
                el.classList.remove("is-show-content-box");
            },300);
        });
    }

    const categoryNavFirst = document.querySelector('.categoryNavEila > ul > li > a');

    if(categoryNavFirst){
        categoryNavFirst.innerText = GLOBALS.tc.show_all;
    }

});
window.addEventListener('load', function() {
    initItemboxListPreview();
    loadLetter();
    initRoadshowForms();
});